
/**
 *
 * @class StickySide
 *
 * indicator for which side of parent bound a child should "stick" to.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export enum StickySide {
  LEFT   = 'left',
  RIGHT  = 'right',
  TOP    = 'top',
  BOTTOM = 'bottom'
}

